import React, { useRef } from 'react'
import { Button } from 'semantic-ui-react'
import EmergencyProcedure from './EmergencyProcedure'

const MassEmergencyDocument = ({ translate, brokerGuid, customStateMapper }) => {
    const popup = useRef()
    return (
        <div className='emergencyDocument'>
            <Button size="mini"
                className='sv todo-button'
                onClick={() => popup.current?.openPopup()} >
                {translate("EMERGENCY_PROCEDURE")}
            </Button>
            <EmergencyProcedure  
                ref={popup}
                translate={translate} 
                brokerGuid={brokerGuid}
                customStateMapper={customStateMapper}
            />
        </div>
    )
}

const MemoizeMassEmergencyDocument = React.memo(MassEmergencyDocument)
export { MemoizeMassEmergencyDocument }